import vodAdapter from 'shared/utils/adapters/vod';
import UPLOADING_STATUSES from 'shared/constants/uploading-statuses';
import ASYNC_UPLOADING_STATUSES from 'shared/constants/async-uploading-statuses';

const UPDATE_PROGRESS_EVENT = vodAdapter.events.UPLOADING_PROGRESS.UPDATE;
const { events } = vodAdapter;

function getUploadingStatusFromTranscoding(transcodingStatus) {
  if (transcodingStatus === ASYNC_UPLOADING_STATUSES.FAILED) {
    return UPLOADING_STATUSES.FAILED;
  } else if (
    transcodingStatus === ASYNC_UPLOADING_STATUSES.INPROGRESS ||
    transcodingStatus === ASYNC_UPLOADING_STATUSES.PREVIEW_READY ||
    transcodingStatus === ASYNC_UPLOADING_STATUSES.READY
  ) {
    return UPLOADING_STATUSES.SUCCEEDED;
  } else if (
    transcodingStatus === ASYNC_UPLOADING_STATUSES.UPLOADING ||
    transcodingStatus === ASYNC_UPLOADING_STATUSES.IN_STORAGE ||
    transcodingStatus === ASYNC_UPLOADING_STATUSES.IN_QUEUE
  ) {
    return UPLOADING_STATUSES.PROCESSING;
  }

  return UPLOADING_STATUSES.UPLOADING;
}

export function subscribeOnAsyncUpdates(fileId, callback) {
  const onUpdate = ({ id, transcodingStatus }) => {
    if (id === fileId) {
      return callback({
        uploadingStatus: getUploadingStatusFromTranscoding(transcodingStatus.toUpperCase()),
      });
    }
  };

  events.on(events.TRANSCODING.UPDATE, onUpdate);

  // return unsubscribe function
  return () => events.off(events.TRANSCODING.UPDATE, onUpdate);
}

export function subscribeOnProgressUpdate(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  const { on } = uploadPromise;
  let prevUploadingStatus = null;

  on(UPDATE_PROGRESS_EVENT, function (progress) {
    const { uploadingStatus } = progress;
    if (
      // fix slow app render
      uploadingStatus === prevUploadingStatus ||
      // for cancellation error recognition. Status will be applied at catch
      uploadingStatus === UPLOADING_STATUSES.FAILED
    ) {
      return;
    }
    prevUploadingStatus = uploadingStatus;

    callback(progress);
  });
}

export function subscribeOnUploadStart(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  const { on, off } = uploadPromise;
  const progressFn = progress => {
    off(UPDATE_PROGRESS_EVENT, progressFn);
    callback(progress);
  };

  on(UPDATE_PROGRESS_EVENT, progressFn);
}

const activeStauses = [UPLOADING_STATUSES.UPLOADING, UPLOADING_STATUSES.PROCESSING];

export function subscribeOnActiveStatusChanged(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  let currentStatus = 'unknown';

  const progressFn = ({ uploadingStatus }) => {
    if (currentStatus === uploadingStatus || !_.includes(activeStauses, uploadingStatus)) {
      return;
    }
    currentStatus = uploadingStatus;
    callback(currentStatus);
  };

  uploadPromise.on(UPDATE_PROGRESS_EVENT, progressFn);
}



// WEBPACK FOOTER //
// ./src/dashboard/utils/progress-update-utils.js